// Per-user, per-workspace recency tracking backed by Firestore.
//
// Subcollection: users/{uid}/workspaceUsage/{workspaceId}
//   { lastAccessedAt: serverTimestamp(), organizationId: string }
//
// Best-effort UX sync across web and mobile; localStorage / AsyncStorage remain primary per device.

import {
  collection,
  doc,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';

async function queryRecentWorkspaceDocs(uid) {
  const db = getFirestore();
  const q = query(
    collection(db, 'users', uid, 'workspaceUsage'),
    orderBy('lastAccessedAt', 'desc'),
    limit(25)
  );
  return getDocs(q);
}

export async function recordWorkspaceUsage(uid, workspaceId, organizationId) {
  if (!uid || !workspaceId) return;
  try {
    const db = getFirestore();
    await setDoc(
      doc(db, 'users', uid, 'workspaceUsage', workspaceId),
      {
        lastAccessedAt: serverTimestamp(),
        organizationId: organizationId || null,
      },
      { merge: true }
    );
  } catch (error) {
    console.warn('recordWorkspaceUsage failed:', error?.message || error);
  }
}

/**
 * @returns {{ workspaceId: string, organizationId: string | null } | null}
 */
export async function getMostRecentWorkspace(uid, allowedIds) {
  if (!uid) return null;
  const allowedSet = new Set(
    Array.isArray(allowedIds) ? allowedIds.filter(Boolean) : []
  );
  if (allowedSet.size === 0) return null;
  try {
    const snap = await queryRecentWorkspaceDocs(uid);
    for (const docSnap of snap.docs) {
      if (!allowedSet.has(docSnap.id)) continue;
      const data = docSnap.data();
      return {
        workspaceId: docSnap.id,
        organizationId: data.organizationId || null,
      };
    }
    return null;
  } catch (error) {
    console.warn('getMostRecentWorkspace failed:', error?.message || error);
    return null;
  }
}

export async function getMostRecentWorkspaceId(uid, allowedIds) {
  const recent = await getMostRecentWorkspace(uid, allowedIds);
  return recent?.workspaceId ?? null;
}
